import { useTranslation } from 'react-i18next'

import { cn } from '#/shared/lib/utils'

/** Bars in the traveling wave — matches the recording island's 12-bar glyph so
 *  the listening→transcribing swap reads as the same object changing behaviour. */
const BAR_COUNT = 12

/** Seconds of phase offset between neighbouring bars. Negative per-bar delays
 *  start each bar further into the same loop, so the crest sweeps left→right. */
const BAR_STAGGER = 0.07

/** Dark pill shown in place of the recording island once the user stops, while
 *  the on-device model transcribes the clip. Display-only (no tap target): the
 *  bars run a traveling wave so it reads as "working, please wait" rather than
 *  "listening". Sized by its wrapper to match the island it replaces. */
export function VoiceProcessingIsland({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <div
      role="status"
      aria-label={t('voice.processing')}
      className={cn(
        'flex h-9 items-center justify-center gap-0.75 rounded-full bg-gray-900 px-3 text-white',
        className,
      )}
    >
      {Array.from({ length: BAR_COUNT }, (_, i) => (
        <span
          key={i}
          aria-hidden
          className="animate-voice-wave h-5 w-0.5 origin-center rounded-full bg-current"
          style={{ animationDelay: `${i * -BAR_STAGGER}s` }}
        />
      ))}
    </div>
  )
}
